import { render, staticRenderFns } from "./AddVehicle.vue?vue&type=template&id=0affab6f&scoped=true&"
import script from "./AddVehicle.vue?vue&type=script&lang=js&"
export * from "./AddVehicle.vue?vue&type=script&lang=js&"
import style0 from "./AddVehicle.vue?vue&type=style&index=0&id=0affab6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0affab6f",
  null
  
)

export default component.exports